import React from 'react'

const DownLoadIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#EAEDFB" />
      <mask
        id="mask0_1197_64600"
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="20"
        height="20"
      >
        <rect x="6" y="6" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1197_64600)">
        <path
          d="M15.9999 18.9793C15.8888 18.9793 15.7846 18.9618 15.6874 18.9268C15.5902 18.8924 15.4999 18.8335 15.4166 18.7502L12.4166 15.7502C12.2638 15.5974 12.1874 15.4029 12.1874 15.1668C12.1874 14.9307 12.2638 14.7363 12.4166 14.5835C12.5694 14.4307 12.7671 14.3507 13.0099 14.3435C13.2533 14.3368 13.4513 14.4099 13.6041 14.5627L15.1666 16.1252V10.1668C15.1666 9.93072 15.2466 9.73266 15.4066 9.57266C15.566 9.41322 15.7638 9.3335 15.9999 9.3335C16.236 9.3335 16.4341 9.41322 16.5941 9.57266C16.7535 9.73266 16.8333 9.93072 16.8333 10.1668V16.1252L18.3958 14.5627C18.5485 14.4099 18.7466 14.3368 18.9899 14.3435C19.2327 14.3507 19.4305 14.4307 19.5833 14.5835C19.736 14.7363 19.8124 14.9307 19.8124 15.1668C19.8124 15.4029 19.736 15.5974 19.5833 15.7502L16.5833 18.7502C16.4999 18.8335 16.4096 18.8924 16.3124 18.9268C16.2152 18.9618 16.111 18.9793 15.9999 18.9793ZM10.9999 22.6668C10.5416 22.6668 10.1494 22.5038 9.82325 22.1777C9.49659 21.851 9.33325 21.4585 9.33325 21.0002V19.3335C9.33325 19.0974 9.41297 18.8993 9.57242 18.7393C9.73242 18.5799 9.93047 18.5002 10.1666 18.5002C10.4027 18.5002 10.6008 18.5799 10.7608 18.7393C10.9202 18.8993 10.9999 19.0974 10.9999 19.3335V21.0002H20.9999V19.3335C20.9999 19.0974 21.0799 18.8993 21.2399 18.7393C21.3994 18.5799 21.5971 18.5002 21.8333 18.5002C22.0694 18.5002 22.2671 18.5799 22.4266 18.7393C22.5866 18.8993 22.6666 19.0974 22.6666 19.3335V21.0002C22.6666 21.4585 22.5035 21.851 22.1774 22.1777C21.8508 22.5038 21.4583 22.6668 20.9999 22.6668H10.9999Z"
          fill="#343E59"
        />
      </g>
    </svg>
  )
}

export default DownLoadIcon
